module.exports = {
	"colors": [
		"#93111e",
		"#E53935",
		"#D81B60",
		"#8E24AA",
		"#3949AB",
		"#1E88E5",
		"#00ACC1",
		"#00897B",
		"#7CB342",
		"#C0CA33",
		"#FFB300",
		"#FB8C00",
		"#F4511E"
	],
	"navigator": {
		"maskFill": "rgba(147, 17, 30, .1)",
		"outlineWidth": 0,
		"series": {
			"type": "line",
			"color": "#93111e"
		}
	},
	"chart": {
		"borderWidth": 0,
		"backgroundColor": null
	},
	"exporting": {
		"enabled": false
	},
	"credits": {
		"enabled": false
	},
	"legend": {
		"enabled": false
	},
	"lang": {
		"thousandSep": ".",
		"decimalPoint": ",",
		"months": [
			"Januar",
			"Februar",
			"März",
			"April",
			"Mai",
			"Juni",
			"Juli",
			"August",
			"September",
			"Oktober",
			"November"
		],
		"shortMonths": [
			"Jan",
			"Feb",
			"Mär",
			"Apr",
			"Mai",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Okt",
			"Nov",
			"Dez"
		],
		"weekdays": [
			"Montag",
			"Dienstag",
			"Mittwoch",
			"Donnerstag",
			"Freitag",
			"Samstag",
			"Sonntag"
		],
		"numericSymbols": null,
		"rangeSelectorZoom": "",
		"rangeSelectorFrom": "Von",
		"rangeSelectorTo": "Bis"
	},
	"responsive": {
		"rules": [
			{
				"condition": {
					"maxWidth": 480
				},
				"chartOptions": {
					"plotOptions": {
						"pie": {
							"dataLabels": {
								"enabled": false
							},
							"showInLegend": true
						}
					},
					"legend": {
						"enabled": true,
						"itemMarginBottom": 5
					}
				}
			}
		]
	}
}